<template>
    <div id="badge_details" class="vld-parent">
        <Modal :title="title" :header="false" :footer="false">
            <template slot="body">
                <bars width="64" height="64" color="#007bff" />
            </template>
        </Modal>
    </div>
</template>

<script>

import Modal from "./Modal.vue";
import Bars from "./Bars.vue";

export default {
    name: 'LoaderModal',

    components: {
        Modal,
        Bars,
    },

    props: {
        header: {
            type: Boolean,
            required: false,
            default: false
        },
        footer: {
            type: Boolean,
            required: false,
            default: false
        },
        title: {
            type: String,
            required: false,
            default: ''
        },
        showCloseButton: {
            title: Boolean,
            required: false,
            default: false,
        }
    }
}
</script>
